import { render, staticRenderFns } from "./sort5.vue?vue&type=template&id=a5683368&scoped=true&"
import script from "./sort5.vue?vue&type=script&lang=js&"
export * from "./sort5.vue?vue&type=script&lang=js&"
import style0 from "./sort5.vue?vue&type=style&index=0&id=a5683368&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5683368",
  null
  
)

export default component.exports